﻿import * as styleTypes from './style/styleTypes';
import { parseStyleRules as parseCanvasStyle } from './style/canvasStyleParser';
import { parseStyleRules as parseWebglStyle } from './style/webglStyleParser';

export function parseStyleRules(rules, type, forceCanvas) {
    if (rules == null) {
        return getEmptyStyle(forceCanvas);
    }

    let styleType;
    if (forceCanvas) {
        styleType = styleTypes.STYLE_TYPE_CANVAS;
    } else {
        styleType = getStyleType(rules);
    }

    switch (styleType) {
        case styleTypes.STYLE_TYPE_WEBGL: return parseWebglStyle(rules, type);
        default: return parseCanvasStyle(rules, type);
    }
}

export function getStyleType(rules) {
    if (rules == null) {
        return styleTypes.STYLE_TYPE_WEBGL;
    }

    let styleType = styleTypes.STYLE_TYPE_WEBGL;
    for (let i = 0; i < rules.length; i++) {
        let rule = rules[i];
        let ruleType = getRuleType(rule);
        if (ruleType == styleTypes.STYLE_TYPE_CANVAS) {
            styleType = styleTypes.STYLE_TYPE_CANVAS;
            i = rules.length;
        }
    }

    return styleType;
}

function getEmptyStyle(forceCanvas) {
    if (forceCanvas) {
        return {
            styleType: styleTypes.STYLE_TYPE_CANVAS,
            style: {
                rules: [],
                name: '',
                abstract: ''
            }
        }
    }

    return {
        styleType: styleTypes.STYLE_TYPE_WEBGL,
        style: {
            featureStyle: [],
            labelStyle: null
        }
    }
}

function getRuleType(rule) {
    let ruleType = styleTypes.STYLE_TYPE_WEBGL;
    for (let i = 0; i < rule.Items.length; i++) {
        let item = rule.Items[i];
        let itemType = '';
        switch (item.$type) {
            case styleTypes.POINT: itemType = styleTypes.STYLE_TYPE_CANVAS/*getPointType(item)*/;
                break;
            case styleTypes.LINE: itemType = styleTypes.STYLE_TYPE_CANVAS/*getLineType(item)*/;
                break;
            case styleTypes.POLYGON: itemType = styleTypes.STYLE_TYPE_CANVAS;
                break;
            case styleTypes.LABEL: itemType = styleTypes.STYLE_TYPE_CANVAS;
                break;
            default: break;
        }

        if (itemType == styleTypes.STYLE_TYPE_CANVAS) {
            ruleType = styleTypes.STYLE_TYPE_CANVAS;
            i = rule.Items.length;
        }
    }

    return ruleType;
}

function getPointType(item) {
    if (item.Graphic != null && item.Graphic.Mark != null && item.Graphic.Mark.WellKnownName != null) {
        if (item.Graphic.Mark.WellKnownName == styleTypes.WKN_CROSS) {
            return styleTypes.STYLE_TYPE_CANVAS;
        } else if (item.Graphic.Mark.WellKnownName == styleTypes.WKN_X) {
            return styleTypes.STYLE_TYPE_CANVAS;
        }
    }

    return styleTypes.STYLE_TYPE_WEBGL;
}

function getLineType(item) {
    if (item.Stroke != null && item.Stroke.GraphicStroke != null && item.Stroke.GraphicStroke.Graphic != null && item.Stroke.GraphicStroke.Graphic.Mark != null) {
        return styleTypes.STYLE_TYPE_CANVAS;
    }

    return styleTypes.STYLE_TYPE_WEBGL;
}

function getPolygonType(item) {
    if (item.Stroke != null && item.Stroke.GraphicStroke != null) {
        return styleTypes.STYLE_TYPE_CANVAS;
    }

    if (item.Fill != null && item.Fill.GraphicFill != null) {
        return styleTypes.STYLE_TYPE_CANVAS;
    }

    if (item.Fill != null && item.Fill.styling != null && item.Fill.styling.fillOpacity > 0.5) {
        return styleTypes.STYLE_TYPE_CANVAS;
    } else if (item.Fill != null && item.Fill.styling != null && item.Fill.styling.fillOpacity > 0 && item.Stroke != null && item.Stroke.styling != null && item.Stroke.styling.strokeDasharray != null && item.Stroke.styling.strokeDasharray.trim() != '') {
        return styleTypes.STYLE_TYPE_CANVAS;
    }

    return styleTypes.STYLE_TYPE_WEBGL;
}